import { PrimaryButton as PrimaryButtonBase } from 'components/misc/Buttons.js';
import ResponsiveVideoEmbed from 'helpers/ResponsiveVideoEmbed';
import styled from 'styled-components';
import tw from 'twin.macro';
import logo from '../../images/logo.png';
import { ReactComponent as SvgDecoratorBlob1 } from '../../images/svg-decorator-blob-1.svg';
import HeroVideo from '../../images/video_2025-08-27_13-09-34.mp4';
import Header, { LogoLink, NavLink, NavLinks } from '../headers/light.js';

const Bold = tw.span`font-bold`;
const PrimaryText = tw.span`text-primary-500`;

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col lg:flex-row lg:items-center max-w-screen-xl mx-auto py-6 md:py-8 pt-8 md:pt-12`;
const LeftColumn = tw.div`relative lg:w-7/12 text-center max-w-lg mx-auto lg:max-w-none lg:text-left`;
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex-1 flex flex-col justify-center lg:justify-center lg:ml-6 lg:mt-16`;

const Heading = tw.h1`font-bold text-3xl md:text-3xl lg:text-4xl xl:text-5xl text-gray-900 leading-tight`;
const Paragraph = tw.p`my-5 lg:my-8 text-base xl:text-lg`;
const BoldParagraph = tw.p`my-5 lg:my-8 text-base xl:text-lg font-bold`;

const Actions = styled.div`
    ${tw`relative max-w-md text-center mx-auto lg:mx-0`}
    input {
        ${tw`sm:pr-48 pl-8 py-4 sm:py-5 rounded-full border-2 w-full font-medium focus:outline-none transition duration-300  focus:border-primary-500 hover:border-gray-500`}
    }
    button {
        ${tw`w-full sm:absolute left-0 top-0 bottom-0 bg-primary-500 text-gray-100 font-bold mr-2 my-4 sm:my-2 rounded-full py-5 px-5 flex items-center justify-center sm:w-56 sm:leading-none focus:outline-none hover:bg-primary-900 transition duration-300`}
    }
`;

const IllustrationContainer = tw.div`flex justify-center lg:justify-end items-center`;
const PrimaryButton = tw(PrimaryButtonBase)`mt-8 md:mt-10 md:mx-0`;

// Random Decorator Blobs (shapes that you see in background)
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
    ${tw`pointer-events-none opacity-5 absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3 -z-10`}
`;

// const CustomersLogoStrip = styled.div`
//     ${tw`mt-12 lg:mt-20`}
//     p {
//         ${tw`uppercase text-sm lg:text-xs tracking-wider font-bold text-gray-500`}
//     }
//     img {
//         ${tw`mt-4 w-full lg:pr-16 xl:pr-32 opacity-50`}
//     }
// `;

export default ({ roundedHeaderButton }) => {
    return (
        <>
            <Header
                roundedHeaderButton={roundedHeaderButton}
                links={[
                    <NavLinks key={1}>
                        <NavLink href="#o-nama">O nama</NavLink>
                        {/* <NavLink href="#utisci">Utisci</NavLink> */}
                        <NavLink href="#pitanja">Česta pitanja</NavLink>
                        <NavLink href="#kontakt">Kontakt</NavLink>
                    </NavLinks>,
                ]}
                logoLink={
                    <LogoLink href="/">
                        <img src={logo} alt="logo" />
                    </LogoLink>
                }
            />
            <Container>
                <TwoColumn>
                    <LeftColumn>
                        <Heading>
                            Analitika za poboljšanje <PrimaryText>performansi poslovanja</PrimaryText>
                        </Heading>

                        <BoldParagraph>
                            Prodajna analiza i automatizacija izveštavanja koja donosi rezultate.
                        </BoldParagraph>
                        <Paragraph>Nastao iz rada s nekoliko malih firmi i testiran u stvarnim slučajevima!</Paragraph>
                        <Paragraph>
                            Prilagođen posebno za vlasnike malih i srednjih firmi koji <Bold>znaju prodavati</Bold> i
                            poznaju svoj posao – ali nemaju uvek jasnu sliku{' '}
                            <Bold>
                                šta se stvarno prodaje, gde se gubi prihod, koji proizvodi ili koji kupci donose profit
                            </Bold>
                            , a koji ga troše.
                        </Paragraph>
                        <Paragraph>
                            Pored toga možemo kreirati analitiku za uvid u druge sfere poslovanja: zaliha, nabavke itd.
                        </Paragraph>
                        <Actions>
                            <PrimaryButton as="a" href="#kontakt">
                                Kontaktirajte nas
                            </PrimaryButton>
                        </Actions>
                        {/* <CustomersLogoStrip>
                            <p>Our TRUSTED Customers</p>
                            <img src={CustomersLogoStripImage} alt="Our Customers" />
                        </CustomersLogoStrip> */}
                    </LeftColumn>
                    <RightColumn>
                        <IllustrationContainer>
                            <ResponsiveVideoEmbed url={HeroVideo} tw="w-full" />
                            {/* <img
                                tw="min-w-0 w-full max-w-lg xl:max-w-xl"
                                src={StatsIllustrationSrc}
                                alt="Stats Illustration"
                            /> */}
                        </IllustrationContainer>
                    </RightColumn>
                </TwoColumn>
                <DecoratorBlob1 />
            </Container>
        </>
    );
};
